<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 9.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>
                Listă cereri
            </h4>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box ">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <app-ajutoare-stats-bar
                            *ngIf="ajutoareStats.length > 0"
                            [stats]="ajutoareStats"
                            [lastUpdated]="statsLastUpdated"
                            [activeKey]="activeStatKey"
                            (statSelected)="onStatFilterSelected($event)"
                            (resetFilter)="onResetStatsFilter()">
                        </app-ajutoare-stats-bar>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <!-- <button type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                    (click)="downloadManual()">
                                    <img src="assets/icons/icon-download.svg" alt="Descarcă" /> &nbsp;Documentație
                                </button> -->
                        </div>
                    </div>
                    <div class="card-container request-filter p-2" *ngIf="showCard">

                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <mat-button-toggle-group
                                *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.filtre-avansate')"
                                name="fontStyle" aria-label="Font Style" (change)="onFiltreChange($event)"
                                value="simple">
                                <mat-button-toggle value="simple">Filtre simple</mat-button-toggle>
                                <mat-button-toggle value="avansate">Filtre avansate</mat-button-toggle>
                            </mat-button-toggle-group>
                            <br />
                            <ng-container *ngIf="selectedFiltre === 'simple'">
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr cerere</mat-label>
                                            <input matInput type="number" formControlName="numarCerere" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr cerere (intern)</mat-label>
                                            <input matInput type="number" formControlName="numarCerereIntern" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row ">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>CNP/CIF</mat-label>
                                            <input matInput type="number" formControlName="cnp_cui" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Denumire Cetățean/PJ</mat-label>
                                            <input matInput type="text" formControlName="cetatean_pj" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Telefon</mat-label>
                                            <input matInput type="number" formControlName="telefon" />
                                        </mat-form-field>
                                    </div>

                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Email</mat-label>
                                            <input matInput type="text" formControlName="email" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr cadastral</mat-label>
                                            <input matInput type="number" pattern="[0-9]{6}"
                                                formControlName="numar_cadastral" />
                                            <mat-error *ngIf="searchParamsForm.get('numar_cadastral')?.invalid">
                                                Câmpul trebuie să conțină exact 6 cifre
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col">
                                        <strong class="m-0">Adresă imobil</strong>
                                        <mat-checkbox formControlName="check_adresa_proprietate"
                                            color="primary"></mat-checkbox>
                                    </div>
                                </div>

                                <div *ngIf="this.searchParamsForm.get('check_adresa_proprietate')?.value">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Strada</mat-label>
                                                <input matInput type="text" formControlName="proprietate_strada" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Număr</mat-label>
                                                <input matInput type="text" formControlName="proprietate_numar" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Scara</mat-label>
                                                <input matInput type="text" formControlName="proprietate_scara" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Bloc</mat-label>
                                                <input matInput type="text" formControlName="proprietate_bloc" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Etaj</mat-label>
                                                <input matInput type="text" formControlName="proprietate_etaj" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Apartament</mat-label>
                                                <input matInput type="text" formControlName="proprietate_apartament" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Observații</mat-label>
                                                <textarea type="text" matInput
                                                    formControlName="proprietate_observatii"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Adresă</mat-label>
                                            <mat-select formControlName="tip_adresa" [(value)]="selectedAddressType">
                                                <mat-option *ngFor="let option of address_type" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div
                                    *ngIf="selectedAddressType == '1' || selectedAddressType == '2' || selectedAddressType == '3'">
                                    <h3 *ngIf="selectedAddressType == '1'">Adăugați adresă domiciliu/reședință </h3>
                                    <h3 *ngIf="selectedAddressType == '2'">Adăugați adresă sediu </h3>
                                    <h3 *ngIf="selectedAddressType == '3'">Adăugați adresă beneficiar </h3>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Județ</mat-label>
                                                <mat-select matSelect formControlName="judet">
                                                    <mat-option *ngFor="let judet of judete" [value]="judet.id">
                                                        {{ judet.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Oraș</mat-label>
                                                <input matInput type="text" formControlName="city" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Strada</mat-label>
                                                <input matInput type="text" formControlName="streetName" />
                                            </mat-form-field>

                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Număr</mat-label>
                                                <input matInput type="text" formControlName="streetNumber" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Filtre Ajutoare (vizibile mereu) -->
                            <h3 class="filter-subheader mt-3">Filtre Ajutoare</h3>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Etapă</mat-label>
                                        <mat-select formControlName="etapa_nr">
                                            <mat-option [value]="null">Toate</mat-option>
                                            <mat-option [value]="1">Etapa 1</mat-option>
                                            <mat-option [value]="2">Etapa 2</mat-option>
                                            <mat-option [value]="3">Etapa 3</mat-option>
                                            <mat-option [value]="4">Etapa 4</mat-option>
                                            <mat-option [value]="5">Etapa 5</mat-option>
                                            <mat-option [value]="6">Etapa 6</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Status plată etapă</mat-label>
                                        <mat-select formControlName="etapa_status">
                                            <mat-option [value]="null">Toate</mat-option>
                                            <mat-option value="pending">În așteptare</mat-option>
                                            <mat-option value="ready_for_payment">Gata de plată</mat-option>
                                            <mat-option value="payment_pending">În procesare</mat-option>
                                            <mat-option value="paid">Plătit</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Status documente etapă</mat-label>
                                        <mat-select formControlName="etapa_docs_status">
                                            <mat-option [value]="null">Toate</mat-option>
                                            <mat-option value="not_uploaded">Neîncărcate</mat-option>
                                            <mat-option value="uploaded">Încărcate</mat-option>
                                            <mat-option value="approved">Confirmate</mat-option>
                                            <mat-option value="rejected">Respinse</mat-option>
                                            <mat-option value="recovery">Recuperare</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Status pre-validare</mat-label>
                                        <mat-select formControlName="pre_validare_status">
                                            <mat-option [value]="null">Toate</mat-option>
                                            <mat-option value="nerepartizat">Nerepartizat</mat-option>
                                            <mat-option value="la_responsabil">La responsabil</mat-option>
                                            <mat-option value="la_anaf">La verificare venituri</mat-option>
                                            <mat-option value="revenit_anaf">Revenit verificare</mat-option>
                                            <mat-option value="respins">Respins</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Responsabil pre-validare</mat-label>
                                        <mat-select formControlName="pre_validare_responsabil_id" (openedChange)="onPvResponsabilClosed()">
                                            <mat-form-field class="px-2 sticky-input">
                                                <input matInput [formControl]="pvResponsabilControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>
                                            <mat-option [value]="null">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let u of filteredPvResponsabili" [value]="u.id">{{ u.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Verificator venituri</mat-label>
                                        <mat-select formControlName="pre_validare_anaf_user_id" (openedChange)="onPvAnafClosed()">
                                            <mat-form-field class="px-2 sticky-input">
                                                <input matInput [formControl]="pvAnafControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>
                                            <mat-option [value]="null">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let u of filteredPvAnaf" [value]="u.id">{{ u.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <ng-container *ngIf="selectedFiltre === 'avansate'">
                                <h3 class="mb-1">Căutare după tip cerere</h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Direcție</mat-label>
                                            <mat-select formControlName="directie" (openedChange)="onDirectiiClosed()"
                                                (selectionChange)="onDirectiiChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="directiiControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let directie of filteredDirectii"
                                                    [value]="directie.id">
                                                    {{ directie.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Compartiment</mat-label>
                                            <mat-select formControlName="compartimentValue"
                                                (openedChange)="onCompartimenteClosed()"
                                                (selectionChange)="onCompartimenteChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="compartimenteControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let compartiment of filteredCompartimente"
                                                    [value]="compartiment.id">
                                                    {{ compartiment.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Cerere</mat-label>
                                            <mat-select formControlName="cerere_types"
                                                (openedChange)="onCerereTypesClosed()">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="tipCerereControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let tipCerere of filteredTipCerere"
                                                    [value]="tipCerere.id">
                                                    {{ tipCerere.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după registre</h3>
                                <div class="row ">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Registru</mat-label>
                                            <mat-select formControlName="registru_types">
                                                <mat-option *ngFor="let registru of registre" [value]="registru.id">
                                                    {{ registru.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>


                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr registru</mat-label>
                                            <input matInput type="number" formControlName="numarRegistru" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după responsabil cerere</h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Direcție responsabil</mat-label>
                                            <mat-select formControlName="directieResponsabil"
                                                (openedChange)="onDirectiiResponsabilClosed()"
                                                (selectionChange)="onDirectiiResponsabilChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="directiiResponsabilControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let directie of filteredDirectiiResponsabil"
                                                    [value]="directie.id">
                                                    {{ directie.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Compartiment responsabil</mat-label>
                                            <mat-select formControlName="compartimentResponsabil"
                                                (openedChange)="onCompartimenteResponsabilClosed()"
                                                (selectionChange)="onCompartimenteResponsabilChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="compartimenteResponsabilControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option
                                                    *ngFor="let compartiment of filteredCompartimenteResponsabil"
                                                    [value]="compartiment.id">
                                                    {{ compartiment.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Responsabil</mat-label>
                                            <mat-select formControlName="operator" (openedChange)="onOperatorClosed()">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="operatoriControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="">-- Alegeți --</mat-option>

                                                <mat-option *ngFor="let operator of filteredOperatori"
                                                    [value]="operator.id">
                                                    {{ operator.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după asignări cerere</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Funcție</mat-label>
                                            <mat-select formControlName="assignmentFunctie"
                                                (openedChange)="onAssignmentFunctiiClosed()"
                                                (selectionChange)="onAssignmentFunctiiChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="assignmentFunctiiControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let functie of filteredAssignmentFunctii"
                                                    [value]="functie.id">
                                                    {{ functie.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Direcție asignare</mat-label>
                                            <mat-select formControlName="assignmentDirectie"
                                                (openedChange)="onAssignmentDirectiiClosed()"
                                                (selectionChange)="onAssignmentDirectiiChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="assignmentDirectiiControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let directie of filteredAssignmentDirectii"
                                                    [value]="directie.id">
                                                    {{ directie.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Compartiment asignare</mat-label>
                                            <mat-select formControlName="assignmentCompartiment"
                                                (openedChange)="onAssignmentCompartimenteClosed()"
                                                (selectionChange)="onAssignmentCompartimenteChange($event.value)">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="assignmentCompartimenteControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="-1">Toate</mat-option>

                                                <mat-option *ngFor="let compartiment of filteredAssignmentCompartimente"
                                                    [value]="compartiment.id">
                                                    {{ compartiment.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Operator asignat</mat-label>
                                            <mat-select formControlName="assignmentOperator"
                                                (openedChange)="onAssignmentOperatorClosed()">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="assignmentOperatoriControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option value="">-- Alegeți --</mat-option>

                                                <mat-option *ngFor="let operator of filteredAssignmentOperatori"
                                                    [value]="operator.id">
                                                    {{ operator.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după operațiuni cerere</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Validat</mat-label>
                                            <mat-select formControlName="status_validat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Invalidat</mat-label>
                                            <mat-select formControlName="status_invalidat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Clasat</mat-label>
                                            <mat-select formControlName="status_clasat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Finalizat</mat-label>
                                            <mat-select formControlName="status_finalizat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                            </ng-container>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start align-items-center">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                            <ng-container *ngIf="checkboxSelections">
                                <button *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.mass-assign')"
                                    class="action-button" (click)="openReassignComponent()">
                                    <span>Repartizare</span>
                                </button>
                                <button *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.mass-update')"
                                    class="action-button" (click)="openChangeStatusComponent()">
                                    <span>Schimbare status</span>
                                </button>
                                <button *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.mass-assign')"
                                    class="action-button" style="background:#ffb74d;color:#333" (click)="openMassAssignVerificareVenituri()">
                                    <span>Alocă verificator venituri</span>
                                </button>
                            </ng-container>
                            <span class="ms-1 text-nowrap text-danger fw-bold" *ngIf="activeFilters"> FILTRE ACTIVE: {{
                                activeFilters }}</span>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <!-- <mat-chip-listbox *ngIf="notificationParameter.name" aria-label="Notification selection">
                                <mat-chip-option>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="chip-title">
                                            {{notificationParameter.name}}
                                        </span>
                                        <span style="margin-left: 3px;" (click)="removeChip()" aria-label="Remove">
                                            <mat-icon>cancel</mat-icon>
                                        </span>
                                    </div>
                                </mat-chip-option>
                            </mat-chip-listbox> -->
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption" (change)="onDateFilterChange()">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'today'
                                                " (click)="setToday()">
                                                <span>ZIUA CURENTĂ</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>ULTIMELE 7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>ULTIMELE 30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>ANUL CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PANA LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="request-filter-container">
                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onStatusChange($event)" [value]="selectedStatusID">
                                <mat-button-toggle *ngFor="let status of statusuriCerere" [value]="status.id">
                                    {{ status.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onCategoryChange($event)" [value]="selectedCategory">
                                <mat-button-toggle *ngFor="let option of categoryToggleOptions" [value]="option.id">
                                    {{ option.value}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>